import React, {useEffect, useState} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Clubs.css';
import { getCorrectListClub } from '../variables';
import logoProAM from '../assets/proam.png'
import logoProBM from '../assets/probm.png'
import logoProAD from '../assets/proad.png'
import logoProBD from '../assets/probd.png'

function Clubs({to = "clubs"}) {
    const navigate = useNavigate();
    const [clubs, setClubs] = useState([]);

    // on récupère le championnat dans l'URL
    const championnat = useLocation().pathname.split('/')[1];

    useEffect(() => {
        const list = getCorrectListClub(championnat) || [];
        setClubs(list);
    }, [championnat])

    // plus d'appel direct à l'API ici; on s'aligne sur les listes mémoire utilisées pour construire les routes

    const resolveSlug = (item) => item.short

    const handleOnClick = (event, value) => {
        let onglet = 1;
        event.preventDefault();

        switch (to) {
            case 'clubs':
                onglet = 4
                break;
            case 'joueurs':
                onglet = 1;
                break;
            default:
                break;
        }

        navigate('/' + championnat + '/' + value, {state:{onglet: onglet}});
    }

    return ( 
        <div className="clubs_page">
            <div className={"top_banniere " + championnat}>
                {
                    championnat == 'proam' &&
                        <span>
                            <img src={logoProAM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'proad' &&
                        <span>
                            <img src={logoProAD} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probm' &&
                        <span>
                            <img src={logoProBM} alt="Logo pro" className="logo_p" />
                        </span>
                }
                {
                    championnat == 'probd' &&
                        <span>
                            <img src={logoProBD} alt="Logo pro" className="logo_p" />
                        </span>
                } 
                <span className="top_banniere_title">
                    {to}
                </span>
            </div>
        
            <div className="clubs_list_clubs">
                {
                    clubs.length > 0 &&
                    clubs.map((item) => {
                        return (
                            <div key={item.id} className={"clubs_club_container " + championnat} onClick={(e)=>handleOnClick(e, resolveSlug(item))}>
                                <img 
                                    src={process.env.PUBLIC_URL + "/images/clubs/" + (item.photo || item.photoClub)}  
                                    alt="" 
                                    width="125" 
                                    height="125"
                                    onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; 
                                        currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                    }}
                                />
                            </div>
                        )
                    })
                } 
            </div>
        </div>
    );
}

export default Clubs;